/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import autosize from 'autosize'
import ReactPlayer from 'react-player'
import { withTranslation } from 'react-i18next'

import './DrillBasicDetail.scss'

import MyStatefulEditor from '../../../common/MyStatefulEditor'
import ScoreNamePopover from '../../subcomponents/ScoreNamePopover'

import check_icon from '../../../../assets/images/common/icons/drills/check.png'
import trash_icon from '../../../../assets/images/common/icons/drills/delete-icon.png'
import NumericScoringCard from '../../subcomponents/NumericScoringCard'
import StarScoringCard from '../../subcomponents/StarScoringCard'

// Stable ids used to look up translated equipment-suggestion examples.
const example_equipment = [
  'domeCones',
  'alignmentSticks',
  'tees',
  'eGolfRing',
  'lowZoneStraps',
  'orangeWhip',
]

class DrillBasicDetail extends React.Component {
  state = {
    scoreNameSelectorOpen: false,
  }

  componentDidMount() {
    for (let i = 0; i < this.props.steps.length; i++) {
      autosize(this[`steps-${i}`])
    }
  }

  componentDidUpdate(_prevProps) {
    for (let i = 0; i < this.props.steps.length; i++) {
      autosize(this[`steps-${i}`])
    }
  }

  // eslint-disable-next-line max-lines-per-function
  render() {
    const { t } = this.props
    const {
      is_drill,
      title,
      description,
      equipment,
      steps,
      content,
      handleInputChange,
      handleArrayInput,
      addListItem,
      removeListItem,
      handleHTML,
      videoPreview,
      videoLoader,
      onVideoAdded,
      removeVideo,
      videoTooLarge,
      videoError,
      video,
      dismissVideoError,
      dismissVideoTooLarge,
      onPhotoAdded,
      photos,
      removePhoto,
      blowUpPhoto,
      originalVideoUrl,
      removeOriginalVideo,
      awsBackupUrl,
      isAdmin,
      // adminVideoOverride,
      // adminVideoUrlOverride,
      // handleAdminVideoOverrideToggle,
      // handleAdminVideoUrlOverrideChange,
    } = this.props
    return (
      <div id='DrillBasicDetail'>
        <div className='page-content-container'>
          <div className='page-column'>
            <p className='input-label'>{t('drills.basicDetail.videoLabel')}</p>
            <div className='video-box'>
              <input
                id='dropzone-upload'
                className='FileInput'
                ref={(ref) => (this.fileInput = ref)}
                type='file'
                accept='video/mp4,video/x-m4v,video/*'
                onChange={onVideoAdded}
                multiple={false}
                // disabled={videoPreview}
                onClick={() => this._nullOutValue('fileInput')}
              />
              <input
                id={'photo-loader'}
                type={'file'}
                accept={'image/*'}
                className={'FileInput'}
                onChange={onPhotoAdded}
                ref={(ref) => (this.photoInput = ref)}
                onClick={() => this._nullOutValue('photoInput')}
              />
              {this._renderVideoBox(
                videoLoader,
                videoTooLarge,
                videoError,
                videoPreview,
                video,
                removeVideo,
                dismissVideoError,
                dismissVideoTooLarge,
                originalVideoUrl,
                removeOriginalVideo,
                awsBackupUrl
              )}
            </div>
            <p className='input-label mt-4'>
              {photos.length > 0
                ? t('drills.basicDetail.imagesLabelCount', {
                  count: photos.length,
                })
                : t('drills.basicDetail.imagesLabelEmpty')}
            </p>
            <div className='image-box'>
              {this._renderPhotoBox(photos, removePhoto, blowUpPhoto)}
            </div>
            <input
              type='text'
              name='title'
              className='title-input mt-3'
              value={title}
              placeholder={
                is_drill
                  ? t('drills.basicDetail.enterDrillName')
                  : t('drills.basicDetail.enterActivityName')
              }
              onChange={handleInputChange}
            />
            <p className='input-label mt-4'>
              {t('drills.basicDetail.briefDescriptionLabel')}{' '}
              <span className='orange-text'>*</span>
            </p>
            <input
              type='text'
              name='description'
              className='description-input mb-3'
              value={description}
              placeholder={
                is_drill
                  ? t('drills.basicDetail.descriptionExampleDrill')
                  : t('drills.basicDetail.descriptionExampleActivity')
              }
              onChange={handleInputChange}
            />
          </div>
          <div className='page-column'>
            {isAdmin && this._renderAdminScoringStuff()}
            <p className='input-label'>
              {t('drills.basicDetail.equipmentNeededLabel')}
              <span className='orange-text'>*</span>
            </p>
            {equipment.length > 0 ? (
              equipment.map((e, i) => (
                <div key={i} className='equipment-row'>
                  <div
                    className='check-icon'
                    style={{ backgroundImage: `url(${check_icon})` }}
                  />
                  <div className='equipment-input-container'>
                    <input
                      id={`equipment-input-uniq-${i}`}
                      type='text'
                      value={e}
                      className='equipment-input'
                      placeholder={t('drills.basicDetail.equipmentExample', {
                        example: t(
                          `drills.basicDetail.equipmentExamples.${
                            example_equipment[i % example_equipment.length]
                          }`
                        ),
                      })}
                      name='equipment'
                      onChange={(e) =>
                        handleArrayInput(e.target.name, i, e.target.value)
                      }
                      onKeyDown={(e) => this._checkKeyDown(e, i, 'equipment')}
                    />
                  </div>
                  <div
                    className='trash-icon'
                    style={{ backgroundImage: `url(${trash_icon})` }}
                    onClick={() => removeListItem('equipment', i)}
                  />
                </div>
              ))
            ) : (
              <div className='placeholder-bar'>
                <p>{t('drills.basicDetail.equipmentEmptyTitle')}</p>
                <p className='subtext'>
                  {is_drill
                    ? t('drills.basicDetail.equipmentEmptySubtextDrill')
                    : t('drills.basicDetail.equipmentEmptySubtextActivity')}
                  {/* search for common {is_drill ? "drills" : "activities"}{" "}
                  later */}
                </p>
              </div>
            )}
            <p
              className='orange-text'
              onClick={() => addListItem('equipment')}
              style={{ cursor: 'pointer', display: 'inline-block' }}
            >
              {t('drills.basicDetail.addEquipmentItem')}
            </p>
            <p className='input-label mt-3'>
              {t('drills.basicDetail.stepsToSetupLabel')}{' '}
              <span className='orange-text'>*</span>
            </p>
            {steps.length > 0 ? (
              steps.map((s, i) => (
                <div key={i} className='equipment-row full-width'>
                  <p>{`${i + 1}.`}</p>
                  <div className='equipment-input-container'>
                    <textarea
                      // type='text'
                      id={`steps-input-uniq-${i}`}
                      value={s}
                      className='equipment-input wrap-input'
                      placeholder={t('drills.basicDetail.stepPlaceholder', {
                        number: i + 1,
                      })}
                      name='steps'
                      onChange={(e) =>
                        handleArrayInput(e.target.name, i, e.target.value)
                      }
                      rows='1'
                      style={{ height: 36 }}
                      ref={(el) => (this[`steps-${i}`] = el)}
                      onKeyDown={(e) => this._checkKeyDown(e, i, 'steps')}
                    />
                  </div>
                  <div
                    className='trash-icon'
                    style={{ backgroundImage: `url(${trash_icon})` }}
                    onClick={() => removeListItem('steps', i)}
                  />
                </div>
              ))
            ) : (
              <div className='placeholder-bar'>
                <p>{t('drills.basicDetail.stepsEmptyTitle')}</p>
                <p className='subtext'>
                  {is_drill
                    ? t('drills.basicDetail.stepsEmptySubtextDrill')
                    : t('drills.basicDetail.stepsEmptySubtextActivity')}
                  {/* search for common {is_drill ? "drills" : "activities"} later */}
                </p>
              </div>
            )}
            <p
              className='orange-text'
              onClick={() => addListItem('steps')}
              style={{ cursor: 'pointer', display: 'inline-block' }}
            >
              {t('drills.basicDetail.addStep')}
            </p>
            <p className='input-label mt-3'>
              {is_drill
                ? t('drills.basicDetail.aboutThisDrill')
                : t('drills.basicDetail.aboutThisActivity')}
              <span className='orange-text'>*</span>
            </p>
            <MyStatefulEditor
              limit={true}
              content={content}
              onChange={handleHTML}
            />
            <div style={{ height: 9 }} />
            {/* above div for styling purposes (temporary) */}
          </div>
        </div>
      </div>
    )
  }

  _checkKeyDown = (e, i, val) => {
    const { addListItem } = this.props
    if (e.key === 'Enter') {
      e.preventDefault()
      addListItem(val)
      setTimeout(() => this._focusNext(i, val), 0)
    }
  }

  _focusNext = (i, val) => {
    const nextEl = document.getElementById(`${val}-input-uniq-${i + 1}`)
    nextEl.focus()
  }

  _renderAdminScoringStuff = () => {
    const {
      t,
      setScoreInfo,
      score_name,
      is_drill,
      scoringEnabled,
      handleScoringToggle,
      is_edit,
    } = this.props
    if (!is_drill) { return null }
    const { scoreNameSelectorOpen } = this.state
    return (
      <div>
        <div className='d-flex justify-content-between'>
          <p className='input-label'>
            {t('drills.basicDetail.enableScoringFeedback')}
          </p>
          <div
            className='custom-control custom-switch mb-3'
            onClick={handleScoringToggle}
          >
            <input
              type='checkbox'
              className='custom-control-input'
              id='scoring-enabler'
              checked={scoringEnabled}
            />
            <label className='custom-control-label input-label'></label>
          </div>
        </div>
        {scoringEnabled && (
          <div>
            <p style={{ fontSize: '0.9rem', color: '#5F6F7C' }}>
              {t('drills.basicDetail.scoreTypeLockNote')}
            </p>
            <div
              className='scoring-container'
              style={{
                backgroundColor: '#f4f4f5',
                padding: 10,
                borderRadius: 8,
                marginBottom: 18,
              }}
            >
              <p>{t('drills.basicDetail.typeLabel')}</p>
              {is_edit && (
                <div className='warning-box'>
                  <p>{t('drills.basicDetail.scoreTypeEditNote')}</p>
                </div>
              )}
              <div
                className='score-name-selector'
                style={{
                  borderRadius: 9,
                  border: '2px solid #34ACE0',
                  background: '#fff',
                  padding: 10,
                  position: 'relative',
                  cursor: 'pointer',
                  marginBottom: 6,
                }}
                onClick={this._toggleScoreNameSelector}
              >
                {this._renderCurrentScoreSelection(score_name)}
                {scoreNameSelectorOpen && (
                  <ScoreNamePopover
                    close={this._toggleScoreNameSelector}
                    setScoreInfo={setScoreInfo}
                    selectedScore={score_name}
                  />
                )}
              </div>
              {this._renderScoringSubQuestions(score_name)}
              {this._renderScoringPreview(score_name)}
            </div>
            {this._renderSkillLevelSelect()}
          </div>
        )}
      </div>
    )
  }

  _renderSkillLevelSelect = () => {
    const { t, allSkillLevels, skillLevelLoader, handleSkillLevelClick } =
      this.props
    if (skillLevelLoader) {
      return (
        <div className='d-flex flex-column align-items-center'>
          <i className='fa fa-spinner fa-spin' aria-hidden='true' />
          <p className='text-center'>
            {t('drills.basicDetail.loadingSkillLevels')}
          </p>
        </div>
      )
    }
    return (
      <div>
        <p>{t('drills.basicDetail.selectSkillLevels')}</p>
        {allSkillLevels.map((sl) => (
          <div key={sl.id}>
            <input
              type='checkbox'
              checked={this._checkSkillLevel(sl.id)}
              onChange={(e) => handleSkillLevelClick(e, sl.id)}
              style={{ maxWidth: 30 }}
            />
            <label>{sl.name}</label>
          </div>
        ))}
      </div>
    )
  }

  _checkSkillLevel = (id) => {
    const { selectedSkillLevels } = this.props
    const resp = selectedSkillLevels.find(
      (sl) => sl.skill_level_id === id && !sl._destroy
    )
    return !!resp
  }

  _renderCurrentScoreSelection = (score_name) => (
    <div className='d-flex align-items-center flex-nowrap'>
      <div style={{ flex: '1 1' }}>
        {this._pickScoreComponent(score_name)}
      </div>
      <div
        className='d-flex align-items-center justify-content-center'
        style={{ fontSize: 24 }}
      >
        <i className='fa fa-angle-down' aria-hidden='true' />
      </div>
    </div>
  )

  _pickScoreComponent = (score_name) => {
    if (score_name === 'numeric') {
      return <NumericScoringCard />
    }
    return <StarScoringCard />
  }

  _toggleScoreNameSelector = () => {
    this.setState((prevState) => ({ scoreNameSelectorOpen: !prevState.scoreNameSelectorOpen }))
  }

  _renderScoringSubQuestions = (name) => {
    const {
      t,
      score_type,
      score_detail,
      score_label,
      star_label_one,
      star_label_five,
    } = this.props
    if (name === 'numeric') {
      return (
        <div className='scoring-section-subquestions'>
          <div className='d-flex'>
            <div className='d-flex align-items-center justify-content-center'>
              <p
                style={{
                  marginRight: 9,
                  whiteSpace: 'nowrap',
                  marginBottom: 0,
                }}
              >
                {t('drills.basicDetail.whatAreYouMeasuring')}
              </p>
            </div>
            <input
              onChange={this._handleScoreLabelChange}
              value={score_label}
              placeholder={t('drills.basicDetail.measuringExample')}
            />
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <p>{t('drills.basicDetail.highOrLowQuestion')}</p>
            <div id='high-low-state-switcher'>
              <div onClick={(_e) => this._handleScoreTypeChange('high')}>
                <p
                  style={
                    score_type === 'high'
                      ? { background: '#34ACE0', color: '#fff' }
                      : {}
                  }
                >
                  {t('drills.basicDetail.scoreHigh')}
                </p>
              </div>
              <div onClick={(_e) => this._handleScoreTypeChange('low')}>
                <p
                  style={
                    score_type === 'low'
                      ? { background: '#34ACE0', color: '#fff' }
                      : {}
                  }
                >
                  {t('drills.basicDetail.scoreLow')}
                </p>
              </div>
            </div>
          </div>
          <div>
            <span>{t('drills.basicDetail.scoringDetailsOptional')}</span>
            <div>
              <textarea
                onChange={this._handleScoreDetailChange}
                value={score_detail}
                placeholder={t('drills.basicDetail.scoringDetailsPlaceholder')}
              ></textarea>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className='scoring-section-subquestions'>
        <div className='d-flex align-items-center'>
          <div className='d-flex align-items-center'>
            <p
              className='mb-0'
              style={{ whiteSpace: 'nowrap', marginRight: 9 }}
            >
              {t('drills.basicDetail.questionToAsk')}
            </p>
          </div>
          <input
            onChange={this._handleScoreLabelChange}
            value={score_label}
            placeholder={t('drills.basicDetail.questionExample')}
          />
        </div>
        <div className='d-flex align-items-center'>
          <div className='d-flex align-items-center'>
            <p
              className='mb-0'
              style={{ whiteSpace: 'nowrap', marginRight: 9 }}
            >
              {t('drills.basicDetail.lowestValueLabel')}
            </p>
          </div>
          <input
            onChange={this._handleLowestStarChange}
            value={star_label_one}
            placeholder={t('drills.basicDetail.lowestValueExample')}
          />
        </div>
        <div className='d-flex align-items-center'>
          <div className='d-flex align-items-center'>
            <p
              className='mb-0'
              style={{ whiteSpace: 'nowrap', marginRight: 9 }}
            >
              {t('drills.basicDetail.highestValueLabel')}
            </p>
          </div>
          <input
            onChange={this._handleHighestStarChange}
            value={star_label_five}
            placeholder={t('drills.basicDetail.highestValueExample')}
          />
        </div>
      </div>
    )
  }

  _handleLowestStarChange = (e) => {
    const { setScoreInfo } = this.props
    const val = e.target.value
    setScoreInfo('star_label_one', val)
  }

  _handleHighestStarChange = (e) => {
    const { setScoreInfo } = this.props
    const val = e.target.value
    setScoreInfo('star_label_five', val)
  }

  _handleScoreLabelChange = (e) => {
    const { setScoreInfo } = this.props
    const val = e.target.value
    setScoreInfo('score_label', val)
  }

  _handleScoreTypeChange = (val) => {
    const { setScoreInfo } = this.props
    setScoreInfo('score_type', val)
  }

  _handleScoreDetailChange = (e) => {
    const { setScoreInfo } = this.props
    const val = e.target.value
    setScoreInfo('score_detail', val)
  }

  _renderScoringPreview = (name) => {
    const { t } = this.props
    if (name === 'numeric') {
      return (
        <div
          style={{
            borderTop: '2px solid #AFB7BD',
            marginTop: 8,
            paddingTop: 8,
          }}
        >
          <p className='text-center mb-2'>
            {t('drills.basicDetail.scoreInputPreview')}
          </p>
          <p
            style={{ color: '#AFB7BD', fontSize: '0.9rem' }}
            className='text-center mb-2'
          >
            {t('drills.basicDetail.myScore')}
          </p>
          <div className='d-flex justify-content-around flex-nowrap'>
            {[0, 1, 2, 3, 4, 5, 6].map((num) => {
              const threeProperties = {
                color: '#fff',
                backgroundColor: '#34ACE0',
                borderRadius: 4,
              }
              return (
                <div
                  style={{
                    opacity: this._grabNumberOpacity(num),
                    flex: '1 1',
                    ...(num === 3 && threeProperties),
                  }}
                  className='d-flex align-items-center justify-content-center'
                  key={num}
                >
                  <p
                    style={{
                      margin: 0,
                      padding: 0,
                      fontSize: 24,
                      fontWeight: 700,
                      color: '#34ACE0',
                      ...(num === 3 && { color: '#fff' }),
                    }}
                  >
                    {num}
                  </p>
                </div>
              )
            })}
          </div>
          <p
            style={{ color: '#AFB7BD', fontSize: '0.9rem' }}
            className='text-center mt-3 mb-1'
          >
            {this.props.score_label || t('drills.basicDetail.measuringFallback')}
          </p>
        </div>
      )
    }
    return (
      <div
        style={{
          borderTop: '2px solid #AFB7BD',
          marginTop: 8,
          paddingTop: 8,
        }}
      >
        <p className='text-center'>
          {t('drills.basicDetail.scoreInputPreview')}
        </p>
        <p
          style={{ color: '#AFB7BD', fontSize: '0.9rem' }}
          className='text-center'
        >
          {this.props.score_label || t('drills.basicDetail.questionFallback')}
        </p>
        <div className='d-flex justify-content-around flex-nowrap'>
          {[0, 1, 2, 3, 4].map((num) => (
            <div
              style={{ flex: '1 1', color: '#34ACE0' }}
              className='d-flex flex-column justify-content-center align-items-center'
              key={num}
            >
              <i
                className={`fa fa-star${num > 1 ? '-o' : ''}`}
                aria-hidden='true'
                style={{ fontSize: 28 }}
              />
              <p
                style={{
                  color: '#AFB7BD',
                  fontSize: '0.9rem',
                  marginBottom: 4,
                  ...([1, 2, 3].includes(num) && { color: '#f4f4f5' }),
                }}
                className='text-center'
              >
                {num === 0
                  ? this.props.star_label_one ||
                      t('drills.basicDetail.lowestValueFallback')
                  : num === 4
                    ? this.props.star_label_five ||
                      t('drills.basicDetail.highestValueFallback')
                    : '.'}
              </p>
            </div>
          ))}
        </div>
      </div>
    )
  }

  _grabNumberOpacity = (num) => {
    switch (num) {
      case 0:
      case 6:
        return 0.33
      case 1:
      case 5:
        return 0.66
      default:
        return 1
    }
  }

  // eslint-disable-next-line max-params
  _renderVideoBox = (
    loader,
    tooLarge,
    uploadError,
    preview,
    video,
    remove,
    dismissError,
    dismissSize,
    originalUrl,
    removeOriginal,
    backupUrl
  ) => {
    const { t } = this.props
    if (originalUrl || backupUrl) {
      return (
        <div className='w-100 d-flex flex-column align-items-center'>
          <p className='remove-original' onClick={removeOriginal}>
            <i className='fa fa-times' aria-hidden='true' />{' '}
            {t('drills.basicDetail.removeVideo')}
          </p>
          <ReactPlayer
            className='drill-react-player'
            url={backupUrl || originalUrl}
            width='100%'
            height='240px'
            controls
          />
        </div>
      )
    }
    if (tooLarge) {
      return (
        <div className='inner-upload-preview'>
          {/* <div className='remove-button' onClick={removeVideo}>
            <i className='fa fa-times' aria-hidden='true' />
          </div> */}
          <div className='preview-placeholder'>
            <i className='fa fa-ban' aria-hidden='true' />
          </div>
          <p className='video-name'>
            {t('drills.basicDetail.videoTooLargeMessage')}
          </p>
          <button className='clear-button' onClick={dismissSize}>
            {t('drills.basicDetail.okButton')}
          </button>
        </div>
      )
    }
    if (uploadError) {
      return (
        <div className='inner-upload-preview'>
          {/* <div className='remove-button' onClick={removeVideo}>
            <i className='fa fa-times' aria-hidden='true' />
          </div> */}
          <div className='preview-placeholder'>
            <i className='fa fa-exclamation-triangle ' aria-hidden='true' />
          </div>
          <p className='video-name'>{uploadError}</p>
          <button className='clear-button' onClick={dismissError}>
            {t('drills.basicDetail.okButton')}
          </button>
        </div>
      )
    }
    if (loader && preview) {
      return (
        <div className='inner-upload-preview'>
          <div className='preview-placeholder'>
            <i className='fa fa-spinner fa-spin' aria-hidden='true' />
          </div>
          <p>{t('drills.basicDetail.holdTight')}</p>
          <p className='video-name'>{preview.name}</p>
          <p>{t('drills.basicDetail.isUploading')}</p>
        </div>
      )
    }
    if (video && !loader) {
      return (
        <div className='inner-upload-preview'>
          <div className='remove-button' onClick={remove}>
            <i className='fa fa-times' aria-hidden='true' />
          </div>
          <div className='preview-placeholder'>
            <i className='fa fa-file-video-o ' aria-hidden='true' />
          </div>
          <p className='video-name'>{preview.name}</p>
        </div>
      )
    }
    return (
      <div className='inner-dashed-box'>
        <div
          className='play-icon-box'
          onClick={() => this._openDialog('fileInput')}
        >
          <i className='fa fa-play-circle' aria-hidden='true' />
        </div>
        <p>{t('drills.basicDetail.clickToAddVideo')}</p>
      </div>
    )
  }

  _renderPhotoBox = (photos, removePhoto, blowUpPhoto) => {
    const { t } = this.props
    const count = photos.length
    if (count === 0) {
      return (
        <div
          className='inner-dashed-box'
          onClick={() => this._openDialog('photoInput')}
        >
          <i className='fa fa-picture-o' aria-hidden='true' />
          <p>{t('drills.basicDetail.clickToAddImages')}</p>
          <i className='fa fa-picture-o' aria-hidden='true' />
        </div>
      )
    }
    return (
      <div className='inner-photo-preview'>
        {photos.map((p, i) => (
          <div
            key={i}
            className='photo-preview photo-preview-image'
            style={{ backgroundImage: `url(${p.src})` }}
            onClick={() => blowUpPhoto(i)}
          >
            <div
              className='photo-remove-btn'
              onClick={(e) => removePhoto(e, i, p.isLocal, p.id)}
            >
              <i className='fa fa-times' aria-hidden='true' />
            </div>
          </div>
        ))}
        {count < 5 && (
          <div
            className='photo-preview loader'
            onClick={() => this._openDialog('photoInput')}
          >
            <i className='fa fa-plus' aria-hidden='true' />
          </div>
        )}
      </div>
    )
  }

  _openDialog = (el) => {
    this[el].click()
  }

  _nullOutValue = (el) => {
    // this method clears out the value of the input so the user can upload the same video/photo after they remove it
    this[el].value = null
  }
}

export default withTranslation()(DrillBasicDetail)
